import PageTypeA from "../components/pageTypeA/PageTypeA";
import { pagesDataA } from "../data/pagesData";

const Page12 = () => {
  return (
    <PageTypeA title={pagesDataA[6].title} subtitle={pagesDataA[6].subtitle} image={pagesDataA[6].image}/>
  );
};

export default Page12;
